import React, { Fragment } from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import { Label, Input, ModalHeader } from 'reactstrap';

import { ClearButton, PrimaryButton } from 'ui/Components';

import styles from './SetPageDetails.css';

/**
 * User sets the new page name
 * @param {object} props - component props
 * @param {string[]} props.flashEventCategoryOptions - supported categories for flash events
 * @param {boolean} props.isFlashEvent - whether or not to render flash event inputs
 * @param {Function} props.onCancel - return to previous screen
 * @param {Function} props.onEnter - handle user saving new page
 * @param {Function} props.onPageCategoryInputChange - input handler
 * @param {Function} props.onPageDateInputChange - input handler
 * @param {Function} props.onPageNameInputChange - input handler
 * @param {Function} props.onPageTimeInputChange - input handler
 * @returns {React.Component} page name submodal
 */
const SetPageDetails = ({
  flashEventCategoryOptions,
  isFlashEvent,
  onCancel,
  onEnter,
  onPageCategoryInputChange,
  onPageDateInputChange,
  onPageNameInputChange,
  onPageTimeInputChange
}) => (
  <Fragment>
    <ModalHeader>Page Details</ModalHeader>
    <div className={classnames(styles.wrapper, 'mt-3')}>
      <div className="d-flex flex-column">
        <Label className="font-weight-bold" for="setPageDetails-name-input">
          Page Name
        </Label>
        <Input
          data-test-id="setPageDetails-name-input"
          id="setPageDetails-name-input"
          onChange={onPageNameInputChange}
          placeholder="Enter Page Name"
          type="text"
        />
        {isFlashEvent && (
          <React.Fragment>
            <Label className="font-weight-bold mt-2" for="setPageDetails-date-input">
              Date
            </Label>
            <Input
              data-test-id="setPageDetails-date-input"
              id="setPageDetails-date-input"
              onChange={onPageDateInputChange}
              placeholder="Flash Event Date"
              type="date"
            />
            <Label className="font-weight-bold mt-2" for="setPageDetails-time-input">
              Time
            </Label>
            <Input
              data-test-id="setPageDetails-time-input"
              id="setPageDetails-time-input"
              onChange={onPageTimeInputChange}
              placeholder="Flash Event Time"
              type="time"
            />
            <Label className="font-weight-bold mt-2" for="setPageDetails-category-input">
              Category
            </Label>
            <Input
              data-test-id="setPageDetails-category-input"
              id="setPageDetails-category-input"
              onChange={onPageCategoryInputChange}
              type="select"
            >
              {flashEventCategoryOptions.map(category => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </Input>
          </React.Fragment>
        )}
      </div>
    </div>
    <div className="d-flex justify-content-end mt-auto">
      <ClearButton className="mr-3" onClick={onCancel} data-test-id="setPageDetails-cancel">
        Go Back
      </ClearButton>
      <PrimaryButton onClick={onEnter} data-test-id="setPageDetails-enter">
        Enter
      </PrimaryButton>
    </div>
  </Fragment>
);

SetPageDetails.propTypes = {
  flashEventCategoryOptions: propTypes.arrayOf(propTypes.string).isRequired,
  isFlashEvent: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  onEnter: propTypes.func.isRequired,
  onPageCategoryInputChange: propTypes.func.isRequired,
  onPageDateInputChange: propTypes.func.isRequired,
  onPageNameInputChange: propTypes.func.isRequired,
  onPageTimeInputChange: propTypes.func.isRequired
};

export default SetPageDetails;
